import { WISHLIST_REQUEST, WISHLIST_SUCCESS, WISHLIST_UPDATE, WISHLIST_DELETE, WISHLIST_FAILURE, WISHLIST_CLEAR } from "../constants/ActionTypes";

const initialState = {
    loading: false,
    wishlistItems: [],
    error: null,
};

export default function wishlistReducer(state = initialState, action) {
    switch (action.type) {
        case WISHLIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case WISHLIST_SUCCESS:
            return {
                ...state,
                loading: false,
                // always replacing data
                wishlistItems: action.data,
            };
        // case WISHLIST_DELETE:
        //     return {
        //         ...state,
        //         loading: false,
        //         // always replacing data
        //         user_details: [],
        //         isAuth: false
        //     };
        case WISHLIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case WISHLIST_CLEAR:
            return {
                ...state,
                loading: false,
                wishlistItems: [],
            };
        default:
            return state;
    }
}
